import { createFileRoute, redirect } from '@tanstack/react-router'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * `/administration/admins/new` redirige vers `/administration/access` en ouvrant la modale de
 * création de compte. La garde `['add', 'users.bo-users.user']` est conservée : un lien entrant sans
 * ce droit tombe sur la page refusée avant la redirection.
 */
export const Route = createFileRoute('/_authenticated/administration/admins/new')({
  staticData: {
    permission: ['add', 'users.bo-users.user'],
  },
  beforeLoad: () => {
    throw redirect({
      to: '/administration/access',
      search: { adminForm: 'new' },
    })
  },
})
withRoutePermissions(Route)
